import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetCampaignList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/campaign/list", //?order_by=created_on&order_dir=desc
        params: {
          page: list.page,
          per_page: list.per_page ? list.per_page : 10,
          campaign_name: "*" + list.campaign_name + "*"
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  PostCapaign({ commit }, campaign) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign",
        data: campaign,
        method: "POST"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  PatchCampaign({ commit }, campaign) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign/" + campaign.campaign_uuid,
        data: campaign.data,
        method: "PATCH"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  DeleteCampaign({ commit }, campaign_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign/" + campaign_uuid,
        method: "DELETE"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  GetCampaign({ commit }, campaign_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign/" + campaign_uuid,
        method: "GET"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  RunCapaign({ commit }, campaign_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign/" + campaign_uuid + "/run",
        method: "POST"
      })
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  StopCapaign({ commit }, campaign_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/campaign/" + campaign_uuid + "/stop",
        method: "POST"
      })
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  HoldCapaign({ commit }, campaign_uuid) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/campaign/" + campaign_uuid + "/hold",
          method: "POST"
        })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
    });
  }
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
